export default __webpack_public_path__ + "static/block-unwanted-content-a64ae1ca8248d3000de69d024f8183cf.png";